var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7462 3H5.24625C2.37375 3 1.57125 3.69 1.50375 6.375C2.95125 6.375 4.12125 7.5525 4.12125 9C4.12125 10.4475 2.95125 11.6175 1.50375 11.625C1.57125 14.31 2.37375 15 5.24625 15H12.7462C15.7462 15 16.4962 14.25 16.4962 11.25V6.75C16.4962 3.75 15.7462 3 12.7462 3Z",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.74496 3V5.625",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.74496 12.375V15",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2687 6.9975L11.7337 7.935C11.7787 8.025 11.8688 8.0925 11.9663 8.1075L13.0013 8.2575C13.2563 8.295 13.3612 8.61 13.1737 8.79L12.4237 9.5175C12.3487 9.585 12.3188 9.69 12.3338 9.795L12.5138 10.8225C12.5588 11.0775 12.2888 11.2725 12.0638 11.1525L11.1412 10.665C11.0512 10.62 10.9388 10.62 10.8488 10.665L9.92625 11.1525C9.69375 11.2725 9.43125 11.0775 9.47625 10.8225L9.65625 9.795C9.67125 9.69 9.64125 9.5925 9.56625 9.5175L8.82375 8.79C8.63625 8.61 8.74125 8.295 8.99625 8.2575L10.0313 8.1075C10.1363 8.0925 10.2187 8.0325 10.2637 7.935L10.7212 6.9975C10.8262 6.765 11.1562 6.765 11.2687 6.9975Z",
    stroke: "#E0AD1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStar);
export default __webpack_public_path__ + "static/media/ticket-star.d09514daac804600139b3dffbed00493.svg";
export { ForwardRef as ReactComponent };